const React = require("react")
const Layout = require("./src/components/Layout/Layout").default;

// eslint-disable-next-line
exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
};
